import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { SystemService } from 'DataAccessLayer/Services/SystemService';

@autoinject
@customElement('edit1')
export class Edit1CustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.toView }) entityId: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityData: any = null;

    private selectedProcedureTypes: Array<any> = [];

    async bind() {
        this.selectedProcedureTypes = [];
        if (ObjectHelper.ObjectIs(this.entityData) && ObjectHelper.ObjectIs(this.entityData.c_SelectedProcedures_FK) && ObjectHelper.ArrayIs(this.entityData.c_SelectedProcedures_FK)) {
            let response: any = await SystemService.Instance.GetEnumeration('ProcedureType', null, null);
            if (ObjectHelper.ObjectIs(response) && this.ObjectIs(response['Items'])) {
                let items: Array<any> = (JSON.parse(JSON.stringify(response['Items'])));
                this.selectedProcedureTypes = response['Items'].filter(item => this.entityData.c_SelectedProcedures_FK.indexOf(item.Id) >= 0);
            }
        }
    }
}